export default __webpack_public_path__ + "static/media/quickDrawDuel.0ec0aea3.png";